(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2720],{

/***/ 13505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useExperiment; }
/* harmony export */ });
/* unused harmony export withExperiment */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _helpers_auth_getDeviceId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32321);
/* harmony import */ var _page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62832);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50456);
/* harmony import */ var _useUserId__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77883);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getUserExperimentBranch(\n        $experimentId: String!\n        $deviceId: String!\n        $websiteId: String\n        $userId: String\n        $countryCode: String\n      ) {\n        getUserExperimentBranch(\n          experimentId: $experimentId\n          websiteId: $websiteId\n          userId: $userId\n          deviceId: $deviceId\n          countryCode: $countryCode\n        ) {\n          branchName\n          createdAt\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function useExperiment(experimentId) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _partial = ref.partial, partial = _partial === void 0 ? true : _partial;
    var website = (0,_page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().website;
    var deviceId = (0,_helpers_auth_getDeviceId__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var userId = (0,_useUserId__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    // Hacky trick to disable apollo validation since this uses the experiments client
    var getUserExperimentBranch = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useApolloQuery */ .Zu)({
        errorPolicy: "ignore",
        clientName: "experiments",
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_5__["default"])(_templateObject()),
        variables: {
            experimentId: experimentId,
            websiteId: website === null || website === void 0 ? void 0 : website._id,
            userId: userId,
            deviceId: deviceId,
            countryCode: website === null || website === void 0 ? void 0 : website.countryCode
        },
        partial: partial,
        fetchPolicy: "cache-first"
    }).getUserExperimentBranch;
    return getUserExperimentBranch === null || getUserExperimentBranch === void 0 ? void 0 : getUserExperimentBranch.branchName;
};
var withExperiment = function(experimentId, Component) {
    // eslint-disable-next-line react/display-name
    return function(props) {
        var branchName = useExperiment(experimentId);
        return /*#__PURE__*/ _jsx(Component, _objectSpread({}, props, {
            experimentBranchName: branchName
        }));
    };
};


/***/ }),

/***/ 66767:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    es_CL: "CLP",
    es_MX: "MXN",
    es_PE: "PEN",
    es_CO: "COP",
    en_US: "USD",
    es_EC: "USD",
    es_CR: "CRC",
    es_AR: "ARS"
});


/***/ }),

/***/ 78263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ formatNumber; }
});

// EXTERNAL MODULE: ./src/i18n/formatNumber/registerLocales.ts + 1 modules
var registerLocales = __webpack_require__(66385);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/i18n/formatNumber/currencyCodes.ts
var currencyCodes = __webpack_require__(66767);
;// CONCATENATED MODULE: ./src/i18n/formatNumber/moneyFormats.ts
/* harmony default export */ var moneyFormats = ({
    es_CL: "$0,0.[00]",
    es_MX: "$0,0.00",
    es_PE: "$0,0.00",
    es_CO: "$0,0.[00]",
    en_US: "$0,0.00",
    es_EC: "$0,0.00",
    es_CR: "$0,0.[00]",
    es_AR: "$0,0.[00]"
});

;// CONCATENATED MODULE: ./src/i18n/formatNumber/index.ts




function formatNumber(number, format, locale, removeSymbolPreffix) {
    locale = locale || __webpack_require__.g.currentLocale || "es_CL";
    (0,registerLocales/* default */.Z)(locale ? [
        locale
    ] : []);
    var numeralFormat = format;
    if (format === "money" || format === "moneyCode") {
        numeralFormat = moneyFormats[locale] || moneyFormats.es_CL;
    }
    if (numeralFormat === "0,0%") {
        numeralFormat = "0,0.[00]%";
    }
    var prevLocale = (numeral_default()).options.currentLocale;
    if (prevLocale !== locale) {
        numeral_default().locale(locale);
    }
    var numeralFormatCurrency = removeSymbolPreffix ? numeralFormat.replace("$", "") : numeralFormat;
    var result = numeral_default()(number).format(numeralFormatCurrency);
    if (prevLocale !== locale) {
        numeral_default().locale(prevLocale);
    }
    if (format === "moneyCode") {
        return "".concat(result, " ").concat(currencyCodes/* default */.Z[locale]);
    } else {
        return result;
    }
};


/***/ }),

/***/ 35451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NavbarLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5434);
/* harmony import */ var _helpers_misc_scrollTo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55192);
/* harmony import */ var _hooks_useWidth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9177);
/* harmony import */ var _page_components_Order_CategoryPage_Content_TopRow_MobileCategoriesMenu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30121);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76701);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









function NavbarLinks(param) {
    var links = param.links, categories = param.categories, cpg = param.cpg;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showMegaMenu = ref[0], setShowMegaMenu = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), categoriesMegaMenu = ref1[0], setCategoriesMegaMenu = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        x: 0,
        y: 0,
        triangleX: 0
    }), positionMenu = ref2[0], setPositionMenu = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref3[0], setOpen = ref3[1];
    var pageWidth = (0,_hooks_useWidth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)();
    var megamenu = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var isMobile = pageWidth < 768;
    var timer = null;
    var handleMouseIn = function(all) {
        var menu = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (timer) {
            clearTimeout(timer);
        }
        setShowMegaMenu(true);
        if (menu) {
            var targetposition = all.target.getBoundingClientRect();
            var x = targetposition.x, y = targetposition.y, width = targetposition.width;
            var megamenuPosition = megamenu.current.getBoundingClientRect();
            var xPosition = (pageWidth - megamenuPosition.width) / 2;
            setPositionMenu({
                x: xPosition,
                y: y,
                triangleX: x - xPosition + width / 3
            });
        }
    };
    var handleMouseOut = function() {
        timer = setTimeout(function() {
            setShowMegaMenu(false);
        }, 500);
    };
    var handleClick = function() {
        setShowMegaMenu(false);
    };
    var sortCategories = function() {
        var categoriesInfo = [];
        categories.sort(function(a, b) {
            if (a.parent && b.parent) {
                return a.index - b.index;
            }
            if (a.parent) {
                return 1;
            }
            if (b.parent) {
                return -1;
            }
            return a.index - b.index;
        });
        categories.forEach(function(category) {
            if (category.parent) {
                var parent = categoriesInfo.find(function(categoryMenu) {
                    return categoryMenu._id === category.parent._id;
                });
                if (parent) {
                    parent.subcategories = parent.subcategories ? _toConsumableArray(parent.subcategories).concat([
                        category
                    ]) : [
                        category
                    ];
                }
            } else {
                categoriesInfo.push(category);
            }
        });
        setCategoriesMegaMenu(categoriesInfo);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        sortCategories();
        return function() {
            // cleanup function: clear timeout on unmount component
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, []);
    if (!links || !links.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().container),
        style: {
            padding: cpg ? "5px 0" : "0 0 10px"
        },
        children: [
            links.map(function(link, index) {
                if (isMobile && link.showMegaMenu) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().link),
                        rel: "noopener noreferrer",
                        onClick: function() {
                            return setOpen(true);
                        },
                        children: link.title
                    }, index);
                }
                if (!link.path.startsWith("/")) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: link.path,
                        target: "_blank",
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().link),
                        rel: "noopener noreferrer",
                        children: link.title
                    }, index);
                }
                var active = link.path === router.asPath;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                    href: isMobile && showMegaMenu ? "/" : link.path,
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        onClick: function() {
                            if (link.showMegaMenu && isMobile) {
                                setOpen(true);
                                return;
                            }
                            if (!active) return;
                            var navbar = document.getElementsByClassName("mainNavbar")[0];
                            var height = navbar.clientHeight;
                            (0,_helpers_misc_scrollTo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                                element: navbar,
                                top: height
                            });
                        },
                        className: active ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().active) : (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().link),
                        onMouseOver: function(event) {
                            if (link.showMegaMenu && !isMobile) {
                                handleMouseIn(event, true);
                            } else {
                                setShowMegaMenu(false);
                            }
                        },
                        onMouseOut: handleMouseOut,
                        children: link.title
                    })
                }, index);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                ref: megamenu,
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().megamenu),
                onMouseOver: handleMouseIn,
                onMouseOut: handleMouseOut,
                style: {
                    top: positionMenu.y + 34,
                    left: positionMenu.x,
                    visibility: showMegaMenu ? "visible" : "hidden"
                },
                children: [
                    categoriesMegaMenu.map(function(category) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().category),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    href: "/pedir/category/".concat(category._id),
                                    passHref: true,
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().categoryTitle),
                                        onClick: handleClick,
                                        children: category.name
                                    })
                                }),
                                category.subcategories ? category.subcategories.map(function(subcategory) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                        href: "/pedir/category/".concat(subcategory._id),
                                        prefetch: false,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().subcategoryTitle),
                                            onClick: handleClick,
                                            children: subcategory.name
                                        })
                                    }, subcategory._id);
                                }) : null,
                                category.subcategories ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    href: "/pedir/category/".concat(category._id),
                                    passHref: true,
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().seeAll),
                                        onClick: handleClick,
                                        children: [
                                            "Ver todos",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_8__/* .MdChevronRight */ .FNi, {
                                                size: 10,
                                                color: "var(--primary-color)"
                                            })
                                        ]
                                    })
                                }) : null
                            ]
                        }, category._id);
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().triangle),
                        style: {
                            top: -34,
                            left: positionMenu.triangleX
                        }
                    })
                ]
            }),
            open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page_components_Order_CategoryPage_Content_TopRow_MobileCategoriesMenu__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                setOpen: setOpen
            })
        ]
    });
};


/***/ }),

/***/ 63359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/ClientSuspense/index.tsx
var ClientSuspense = __webpack_require__(88385);
// EXTERNAL MODULE: ./src/components/LoadingText/index.tsx + 1 modules
var LoadingText = __webpack_require__(69840);
// EXTERNAL MODULE: ./src/components/SafeSuspense/index.tsx
var SafeSuspense = __webpack_require__(5822);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/lodash/isArray.js
var isArray = __webpack_require__(1469);
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
;// CONCATENATED MODULE: ./src/hooks/useHasUserRoleInWebsite.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getMeInWebsiteRoles($websiteId: ID) {\n        me {\n          _id\n          roles\n          roleInWebsite(websiteId: $websiteId) {\n            _id\n            role\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





// any of these roles
function UseHasUserRoleInWebsite(roles) {
    roles = isArray_default()(roles) ? roles : [
        roles
    ];
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var me = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first",
        partial: true,
        omit: (0,isServerSide/* default */.Z)()
    }).me;
    if ((0,isServerSide/* default */.Z)()) return false;
    if (!me) return false;
    if (me.roles && me.roles.includes("admin")) return true;
    if (!websiteId) return false;
    if (!me.roleInWebsite) return false;
    return roles.includes(me.roleInWebsite.role);
};

// EXTERNAL MODULE: ./src/page-components/Layout/useInitialData.ts
var useInitialData = __webpack_require__(62832);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/components/Image/index.tsx
var Image = __webpack_require__(56036);
// EXTERNAL MODULE: ./src/helpers/websites/getAdminDashboardUrl.ts + 1 modules
var getAdminDashboardUrl = __webpack_require__(30531);
// EXTERNAL MODULE: ./src/hooks/useLogo.ts
var useLogo = __webpack_require__(31778);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/AdminBar/styles.module.css
var styles_module = __webpack_require__(75001);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/AdminBar/index.tsx











function AdminBar(props) {
    var pages = props.pages;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "layout.layouts.default.navbar.adminBar"
    }).t;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), currentPage = ref[0], setCurrentPage = ref[1];
    var ref1 = (0,react.useState)(null), currentProduct = ref1[0], setCurrentProduct = ref1[1];
    var logoUrl = (0,useLogo/* default */.Z)({
        darkMode: false
    });
    (0,react.useEffect)(function() {
        var pathname = router.asPath;
        var current = pages.find(function(page) {
            return page.path === pathname;
        });
        if (current) {
            setCurrentPage(current._id);
            setCurrentProduct(null);
        } else {
            setCurrentPage(null);
            if (pathname.includes("pedir")) {
                var path = pathname.split("/");
                if (path.length === 4 && path[2] !== "category") {
                    setCurrentProduct(path[2]);
                }
            }
        }
    }, [
        router.pathname,
        pages
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((styles_module_default()).container, " ").concat(currentProduct ? (styles_module_default()).fixedContainer : null),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).logoJusto,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    width: "55",
                    height: "16",
                    src: logoUrl,
                    alt: "Logo de Justo"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).actions,
                children: [
                    currentPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: (0,getAdminDashboardUrl/* default */.Z)(websiteId, "/pages/".concat(currentPage, "/components")),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            target: "_blank",
                            className: (styles_module_default()).edit,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdEdit */.zmo, {}),
                                " ",
                                t("labelEditPage")
                            ]
                        })
                    }) : null,
                    currentProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: (0,getAdminDashboardUrl/* default */.Z)(websiteId, "/products/".concat(currentProduct, "/information")),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            target: "_blank",
                            className: (styles_module_default()).edit,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdEdit */.zmo, {}),
                                " ",
                                t("labelEditProduct")
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: (0,getAdminDashboardUrl/* default */.Z)(websiteId, ""),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            target: "_blank",
                            className: (styles_module_default()).admin,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdExitToApp */.IUz, {}),
                                " ",
                                t("labelGoToAdmin")
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Links/index.tsx
var Links = __webpack_require__(35451);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Logo/styles.module.css
var Logo_styles_module = __webpack_require__(86879);
var Logo_styles_module_default = /*#__PURE__*/__webpack_require__.n(Logo_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Logo/index.tsx





function Logo(props) {
    var website = props.website, config = props.config, className = props.className;
    var logo = config.logo;
    var url = logo === null || logo === void 0 ? void 0 : logo.url;
    if (!url) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Logo_styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: className,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Logo_styles_module_default()).imageContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            priority: true,
                            layout: "fill",
                            src: url,
                            objectFit: "contain",
                            alt: website.name || "logo",
                            title: website.name || "logo"
                        })
                    })
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/Menu/index.tsx + 5 modules
var Menu = __webpack_require__(97294);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/styles.module.css
var Navbar_styles_module = __webpack_require__(35606);
var Navbar_styles_module_default = /*#__PURE__*/__webpack_require__.n(Navbar_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Layout/Website/Layouts/Default/Navbar/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Navbar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Navbar_templateObject() {
    var data = Navbar_taggedTemplateLiteral([
        "\n      query userPreferencesNavbar($websiteId: ID!) {\n        userPreferences(websiteId: $websiteId) {\n          _id\n          store {\n            _id\n            name\n          }\n          tableName\n        }\n      }\n    "
    ]);
    Navbar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















function Navbar() {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var userPreferences = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(Navbar_templateObject()),
        partial: true,
        variables: {
            websiteId: websiteId
        },
        omit: !websiteId || (0,isServerSide/* default */.Z)()
    }).userPreferences;
    var website = (0,useInitialData/* default */.Z)().website;
    var isAdmin = UseHasUserRoleInWebsite("admin");
    var navbar = website && website.navbarConfiguration || {
        backgroundColor: "#fff",
        textColor: "#111",
        logo: null,
        buttonColor: null,
        links: null
    };
    var _logo;
    var finalLogo = (_logo = navbar.logo) !== null && _logo !== void 0 ? _logo : website.logo;
    var renderLogo = function(logoProps) {
        return finalLogo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, _objectSpread({
            config: navbar,
            website: website
        }, logoProps)) : null;
    };
    var renderMenu = function() {
        var _buttonColor;
        return(// @ts-expect-error ts-migrate(2740) FIXME: Type '{ pointsConfiguration: websiteInitialData_we... Remove this comment to see the full error message
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
            pointsConfiguration: website.pointsConfiguration,
            buttonColor: (_buttonColor = navbar.buttonColor) !== null && _buttonColor !== void 0 ? _buttonColor : "#252525"
        }));
    };
    var renderLinks = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* default */.Z, {
            links: navbar.links,
            categories: website.categories
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isAdmin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText/* default */.Z, {}),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminBar, {
                    pages: website.pages
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Navbar_styles_module_default()).container,
                style: {
                    backgroundColor: navbar.backgroundColor,
                    color: navbar.textColor
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText/* default */.Z, {}),
                            children: renderMenu()
                        }),
                        renderLogo(),
                        renderLinks()
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 30121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MobileCategoriesMenu; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5434);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69528);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50456);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32533);
/* harmony import */ var _GoBack_styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95420);
/* harmony import */ var _GoBack_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_GoBack_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61524);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_8__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getCategoriesForMenu($websiteId: ID) {\n    categories(websiteId: $websiteId) {\n      items {\n        _id\n        name\n        subCategories {\n          items {\n            _id\n            name\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var styles = _objectSpread({}, (_GoBack_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default()), (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default()));
var query = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_9__["default"])(_templateObject());
function MobileCategoriesMenu(param) {
    var setOpen = param.setOpen;
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), selected = ref4[0], setSelected = ref4[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)().t;
    var i18nGeneric = "generic:fields";
    var i18nWebsite = "website:order";
    var ref1 = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useApolloQuery */ .Zu)({
        query: query,
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first"
    }), categories = ref1.categories, loading = ref1.loading;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if ((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes("/pedir/category/")) {
            var ref2, ref3;
            var categoryIdSelected = (ref3 = (ref2 = router.asPath) === null || ref2 === void 0 ? void 0 : ref2.split("/")) === null || ref3 === void 0 ? void 0 : ref3.pop();
            setSelected(categories.items.find(function(category) {
                return category._id === categoryIdSelected;
            }));
        }
    }, [
        router,
        categories.items
    ]);
    if (loading || !categories) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: styles.closeMenu,
                    onClick: function() {
                        return setOpen(false);
                    },
                    children: t("".concat(i18nGeneric, ".close"))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: styles.loadingContainer,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: styles.closeMenu,
                onClick: function() {
                    return setOpen(false);
                },
                children: t("".concat(i18nGeneric, ".close"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: styles.container,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: styles.categories,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: styles.header,
                            children: [
                                selected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: styles.textWithIcon,
                                    onClick: function() {
                                        return setSelected(null);
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_10__/* .MdKeyboardArrowLeft */ .sG8, {
                                        size: "22"
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: selected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: styles.primaryColor,
                                        onClick: function() {
                                            setOpen(false);
                                            router.push("/pedir/category/".concat(selected._id));
                                        },
                                        children: selected.name
                                    }) : t("".concat(i18nWebsite, ".labelCategories"))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: styles.categoriesList,
                            children: (selected ? selected.subCategories : categories).items.map(function(category, idx) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: styles.categoryItem,
                                    onClick: function() {
                                        setOpen(false);
                                        router.push("/pedir/category/".concat(category._id));
                                        setSelected(category);
                                    },
                                    children: category.name
                                }, idx);
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 75001:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1CYsTvZrzxbIIy4bnAiBzh","fixedContainer":"_3zGpaTTaF5AFr02URZcpXA","logoJusto":"_2LJ8lENyrF0iC50pwq99K-","actions":"JUG4pr-eM52hFE9O-siE7","edit":"_1wNPsswBOaXO6q9Sn3FMBM"};

/***/ }),

/***/ 76701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Bhhe5k9a_WLWLClklHD0I navbarLinksContainer","link":"_29RJklgC4kkTuDEjlOL0vL navbarLink appSubtitle","active":"BELM7cMsLwitWOnC5Cfn_ _29RJklgC4kkTuDEjlOL0vL navbarLink appSubtitle primaryColor","megamenu":"SCb_lPI4rQjnCY6wHU4UV","category":"_1fzOLdBax7bU6GI30z36Yh","categoryTitle":"_1jn8AhOjSPwFIPvbXE7fLe","subcategoryTitle":"_3C3QuVtyaKRxGmz2b2Do7H","seeAll":"x92lcwfCKfD5E6YzFCnaM","triangle":"iKj56B1nmRbQyMvLqOQm5"};

/***/ }),

/***/ 86879:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3uQHIh8W-vaTegatV7ybU7","imageContainer":"_3FqAWjFlHSfPln4gH8Ox5B","center":"_3G14ohfaylXrXoUu50Axdr"};

/***/ }),

/***/ 35606:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1nTtu8akkEjog9aCcj3omW mainNavbar","containerTableOrder":"_3-PxZIb2cVBpR56ih-j07l","flex":"_2SiMSdmI93nb-fdN4pLko_","sections":"_1kntLHPEXHmKdXSL86qT2u"};

/***/ }),

/***/ 95420:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"forceColor":"_1FzGGrusCYvYM-XueTBsvV","textWithIcon":"_3RcLU2MDzPtl_RR3SB2g47","containerFilter":"_1XFUzAhca6UjQUXXl4C2bR","spaceLeft":"_8J5l1mYim_zM0CNKAr823"};

/***/ }),

/***/ 61524:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"closeMenu":"WWe4KToHi9GTHFilq-GsV backgroundBorderColor","container":"_3Ig1X2CpRdxln0tBfFuzs8","loadingContainer":"wRPw54j3maLrgH2qY5FNO _3Ig1X2CpRdxln0tBfFuzs8","categories":"_3gONsDeMv_nq-sU7Li3y7a","categoriesList":"_2UXV5eFFzhuUB_yAI_P6W7","categoryItem":"_3uZcKFmu1Q7TOMGRVzXrJp","header":"qIhDQetEVCYUMdj4bdCN3","primaryColor":"_37MkYbCMjWTk8635JHCKR6"};

/***/ })

}]);